import { render, staticRenderFns } from "./parentStudentList.vue?vue&type=template&id=bb75a69e&"
import script from "./parentStudentList.vue?vue&type=script&lang=js&"
export * from "./parentStudentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb75a69e')) {
      api.createRecord('bb75a69e', component.options)
    } else {
      api.reload('bb75a69e', component.options)
    }
    module.hot.accept("./parentStudentList.vue?vue&type=template&id=bb75a69e&", function () {
      api.rerender('bb75a69e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/teammanagemant/parentList/parentStudentList.vue"
export default component.exports